module.exports = __webpack_public_path__ + "static/media/70A61752-15DA-4799-B891-F9E6D973D186.80a18d69.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/make_over/70A61752-15DA-4799-B891-F9E6D973D186.jpg
// module id = 303
// module chunks = 0